import { PostCode } from 'types';

export function postCodeFactory(data: any = {}): PostCode {
  const { code, deadLine } = data;
  return {
    code: code || '',
    deadLine: new Date(deadLine || 0),
  };
}
